/** Per-docket AI assistant personas — label, colors, quick asks, intro copy.
 * The floating assistant pill picks one of these based on the current route. */

export const PERSONAS = {
  nature: {
    key: "nature",
    label: "Nature Pulse",
    tagline: "Friendly eco educator · grounded in your Pulse",
    intro: "Ask anything about air, water, climate, wildlife, or how to live lighter on the planet. I'll use your saved Pulse location and end with one action you can take today.",
    placeholder: "Ask about air, water, wildlife, climate…",
    faqLink: { to: "/faq", label: "Browse the full FAQ" },
    gradFrom: "#B85F2A", gradVia: "#D07437", gradTo: "#E4A15C",
    shadow: "rgba(184,95,42,.35)",
    quickAsks: [
      "What does AQI 100 mean?",
      "Why is the air worse today near me?",
      "How can I cut my plastic use this week?",
      "Explain climate change to my child",
      "Why do coral reefs bleach?",
      "Give me one impactful action for today",
    ],
  },
  science: {
    key: "science",
    label: "Science Pulse",
    tagline: "Your science tutor · four levels of depth",
    intro: "Ask me any science question — I'll answer at your level and point you to the full multi-level explainer when we have one. Kids to researchers, all welcome.",
    placeholder: "Ask a science question — atoms, black holes, DNA…",
    faqLink: { to: "/science", label: "Browse the knowledge map" },
    gradFrom: "#155E75", gradVia: "#0C4A6E", gradTo: "#1D4ED8",
    shadow: "rgba(12,74,110,.35)",
    quickAsks: [
      "Explain black holes at student level",
      "Why is the sky blue?",
      "What is the scientific method?",
      "How does photosynthesis work?",
      "What is CRISPR?",
      "Give me one surprising science fact",
    ],
  },
  weather: {
    key: "weather",
    label: "Weather Pulse",
    tagline: "Weather educator · observe the sky safely",
    intro: "Ask me about clouds, storms, forecasts or how to observe the weather from your window. I use your saved location, and for severe weather I always point you to official warnings.",
    placeholder: "Ask about clouds, rain, storms, forecasts…",
    faqLink: { to: "/weather-pulse/learn", label: "Open the learning hub" },
    gradFrom: "#0369A1", gradVia: "#0284C7", gradTo: "#38BDF8",
    shadow: "rgba(2,132,199,.35)",
    quickAsks: [
      "Which clouds bring rain?",
      "Is it safe to go out in a thunderstorm?",
      "Weather vs climate — what's the difference?",
      "How do I measure rainfall at home?",
      "Why is the city hotter than the countryside?",
      "What weather should I look for today?",
    ],
  },
  farmers: {
    key: "farmers",
    label: "Farmers Pulse",
    tagline: "Plain-spoken farm advisor · crops to markets",
    intro: "Ask me about sowing windows, soil, water, pests, weather planning or markets. Tell me your crop and region for sharper answers — and confirm pest diagnoses with your local extension officer.",
    placeholder: "Ask about sowing, soil, prices, pests…",
    faqLink: { to: "/farmers/crops", label: "Browse crop insights" },
    gradFrom: "#2D8659", gradVia: "#1B4332", gradTo: "#3F6212",
    shadow: "rgba(27,67,50,.35)",
    quickAsks: [
      "When should I sow wheat?",
      "How do I read a forecast before spraying?",
      "What improves soil health quickly?",
      "How do I start a rainfall journal?",
      "Which crops suit a dry season?",
      "How do mandi prices move?",
    ],
  },
};

/** Route → persona key. */
export function personaForPath(pathname = "") {
  if (pathname.startsWith("/science")) return "science";
  if (pathname.startsWith("/weather-pulse")) return "weather";
  if (pathname.startsWith("/farmers") || pathname.startsWith("/f/")) return "farmers";
  return "nature";
}
